import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { UserRoleService, AlertService } from '@app/_services';
import { ApiResponse } from '@app/_models';

@Component({
    selector: 'app-user-role',
    templateUrl: './user-role.component.html',
    styleUrls: ['./user-role.component.css'],
    standalone: false
})
export class UserRoleComponent implements OnInit
{

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private userRoleService: UserRoleService,
		private alertService: AlertService,
		private location: Location,
		private formBuilder: UntypedFormBuilder) { }

	// structure
	subscription: Subscription;
	routerLocation = this.location;


	// data
	userRoleApiResponse: ApiResponse;
	userRole;
	userRoleId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;

	validationMessages = {
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'maxlength', message: '15 characters maximum' }],
		'description': [
			{ type: 'required', message: 'Required' },
			{ type: 'maxlength', message: '128 characters maximum' }]
	};


	ngOnInit()
	{

		// formAction
		this.formAction = this.router.url.startsWith('/user-role-add') ? 'add' : this.router.url.startsWith('/user-role-edit') ? 'edit' : this.router.url.startsWith('/user-role-view') ? 'view' : '/';

		/**
				 *
				 *
				 *
				 * DATA
				 *
				*/

		// -------------------------------------------------------------------------------------------------
		// no advanced data handlers
		// -------------------------------------------------------------------------------------------------


		/**
				 *
				 *
				 *
				 * ACTIONS (ADD / EDIT / DETAIL)
				 *
				 */
		try
		{
			// add
			if (this.formAction === 'add')
			{
				this.formLabels['title'] = 'Add New User Role';
				this.formReadOnly = false;
				this.formBuild();
			}

			// edit
			else if (this.formAction === 'edit')
			{

				this.subscription = this.activatedRoute.params.subscribe(params =>
				{
					this.userRoleId = params.userRoleId; // (+) converts string 'id' to a number
				});
				this.formLabels['title'] = 'Edit';
				this.formReadOnly = false;
				this.formBuild();

				// get data
				this.userRole = this.findById(+this.userRoleId);

				// patch in data
				this.form1.patchValue(this.userRole);
			}

			// view
			else if (this.formAction === 'view')
			{
				this.subscription = this.activatedRoute.params.subscribe(params =>
				{
					this.userRoleId = params.userRoleId; // (+) converts string 'id' to a number
				});
				this.formLabels['title'] = '';
				this.formReadOnly = true;
				this.formBuild();

				// get data
				this.userRole = this.findById(+this.userRoleId);

				// patch in data
				this.form1.patchValue(this.userRole);
			}
		}
		catch (error)
		{
			console.log('Error: ' + error);
		}
	}


	formBuild()
	{
		/**
				   *
				   *
				   *
				   * FORM
				   *
				   */

		this.form1 = this.formBuilder.group({
			userRoleId: [this.userRoleId],
			createDate: [],
			name: ['', Validators.compose([
				Validators.required,
				Validators.maxLength(15)
			])],
			description: ['', Validators.compose([
				Validators.required,
				Validators.maxLength(128)
			])]
		});
	}

	formAdd()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}

			this.formLoading = true;

			this.userRoleService.add(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('user-role-add SUCCESS: ' + JSON.stringify(res));
						this.userRoleId = res.data.userRole.userRoleId;
						this.router.navigate(['/user-role-view', this.userRoleId]);
					},
					err =>
					{
						console.log('user-role-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	formUpdate()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}

			this.formLoading = true;

			this.userRoleService.update(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('user-role-update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.router.navigate(['/user-role-view', this.userRoleId]);
					},
					err =>
					{
						console.log('user-role-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	findById(id: number)
	{
		try
		{
			this.formLoading = true;
			this.userRoleService.findById(id)
				.subscribe(
					res =>
					{
						console.log('user-role-find SUCCESS: ' + JSON.stringify(res));
						this.userRoleApiResponse = res;
						this.userRole = res.data.userRole;
						this.form1.patchValue(this.userRole);

					},
					err =>
					{
						console.log('user-role-find FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}
}
